import { requestApi } from './Api';

export const setupDocumoFax = (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/documo/setup_fax',
    params
  });
